module.exports = __webpack_public_path__ + "static/img/gzjh.b7f38c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzjh.png
// module id = M09m
// module chunks = 1